module.exports = __webpack_public_path__ + "static/img/logo-sm.bdfa2b47.png";